import React from 'react'
import { useSelector } from 'react-redux'
import ChatBotWebai from './ChatBotWebai'
// import ChatGoogleBusinessai from './ChatGoogleBusinessai'
import ChatGoogleBusinessai from './ChatGoogleBussinessai'

const PreviewChatai = ({ isWhiteLable }) => {
    const state = useSelector(state => state);
    return (
        <section className='business_profile py-5'>
            <div className='container'>
                <div className='row justify-content-center'>
                    {/* <div className='col-md-10"col-lg-3 position-relative text-center'> */}
                    <div class="col-md-9">
                        <div className='row justify-content-center'>
                            {/* <div className="col-lg-4 position-relative text-center"> */}
                            {/* <div class="col-lg-6 col-md-12 col-sm-12 position-relative">
                                <ChatGoogleBusinessai isWhiteLable={isWhiteLable} />
                            </div> */}
                            <div className='col-lg-5'>
                                <h3 className="mb-4 fs-5 fw-bold text-center" style={{ textTransform: 'none' }}>How we look on your website</h3>
                                {state &&
                                    <ChatBotWebai isWhiteLable={isWhiteLable} />
                                }
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </section>
    )
}

export default PreviewChatai